import React from 'react'
import { Helmet } from 'react-helmet'
import { Link } from 'react-router-dom'

import emptyStateImage from 'assets/images/no-team-empty-state.png'
import Content from 'components/common/Content'
import { Columns, Column } from 'components/common/Grid'
import Image from 'components/common/Image'
import Text from 'components/common/Text'
import Header, { Heading } from 'components/navigation/Header'
import theme from 'theme'

export default function NoTeamLandingPage(): React.ReactNode {
  return (
    <>
      <Helmet title="Welcome to Gremlin" />
      <Header>
        <Heading>Welcome to Gremlin</Heading>
      </Header>
      <Content>
        <Columns
          columns={1}
          css={{ width: '100%' }}
          gap={theme.space[3]}
          justify="center"
        >
          <Column>
            <Image
              css={{ width: 575, height: 575 }}
              loading="eager"
              src={emptyStateImage}
            />

            <Text
              as="h2"
              color="medium"
              css={{ textAlign: 'center', marginBottom: theme.space[2] }}
            >
              No Team Assignment
            </Text>
            <Text
              as="p"
              color="dark"
              css={{ textAlign: 'center', marginBottom: theme.space[3] }}
            >
              You need to be a member of a team to start running experiments.
              <br />
              Contact your manager or Company Owner to be added to the team.
            </Text>
            <Text
              as="p"
              color="dark"
              css={{
                textAlign: 'center'
              }}
            >
              You can still access your <Link to="/profile">Settings</Link> from
              here.
            </Text>
          </Column>
        </Columns>
      </Content>
    </>
  )
}
